import { render, staticRenderFns } from "./VirtualNetworkDetails.vue?vue&type=template&id=08fb222e&scoped=true&"
import script from "./VirtualNetworkDetails.vue?vue&type=script&lang=js&"
export * from "./VirtualNetworkDetails.vue?vue&type=script&lang=js&"
import style0 from "./VirtualNetworkDetails.vue?vue&type=style&index=0&id=08fb222e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fb222e",
  null
  
)

export default component.exports